<template>
  <div class="market-place w-screen bg-gray-700" style="min-height:100vh">
    <Header selected="marketplace" class="shadow" />
    <div class="p-4">
      <h1 class="text-xl text-teal-200 font-bold px-2">Templates</h1>
      <div class="flex flex-wrap">
        <div v-for="(item,i) of list" :key="i" class="p-2 rounded w-full sm:w-1/2 md:w-1/4">
          <div class="bg-white shadow rounded overflow-hidden p-2">
            <div class="overflow-scroll h-64 relative" ref="html">
              <div class="absolute h-full w-full top-0 left-0 z-40">
                <button
                  @click="onEditTemplate(item)"
                  type="button"
                  class="p-1 text-xs rounded-r px-4 bg-gray-800 text-white outline-none items-center flex"
                >
                  <Edit3Icon size="12" />
                  <div class="px-2">Edit</div>
                </button>
              </div>
              <div v-html="item.data().code" style="zoom:20%" class="h-full"></div>
            </div>
            <div class="text-gray-700 text-sm flex justify-between items-center">
              <div>
                <div class="pl-1 font-bold">{{item.data().name}}</div>
                <div class="text-xs text-gray-600 flex items-center">
                  <div class="w-4 h-4 rounded-full border flex items-center justify-center">
                    <img
                      v-if="getUser(item).photoURL"
                      :src="getUser(item).photoURL"
                      alt="dp"
                      class="w-4"
                    />
                    <UserIcon v-else size="12" />
                  </div>
                  <div class="ml-1">@{{getUser(item).displayName}}</div>
                  <div
                    @click="deleteComponent(item)"
                    class="ml-1 text-red-600 cursor-default"
                    v-if="user.user.displayName === 'wadasol team'"
                  >delete</div>
                </div>
              </div>
              <div class="border rounded p-1 text-xs px-2 bg-blue-600 text-white">Free</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapState } from "vuex";
import { AppService } from "../store/app.service";

export default {
  name: "MarketPlace",
  components: {},
  data() {
    return {
      list: []
    };
  },
  mounted() {
    AppService.allComponentsOnChange(list => {
      this.list = list.docs;
    });
  },
  computed: {
    ...mapState(["user"])
  },
  methods: {
    ...mapActions(["login", "editTemplate", "deleteComponent"]),
    getUser(item) {
      const user = item.data().user;
      if (user) {
        return user;
      } else {
        return {
          displayName: "anonymous",
          photoURL: null,
          email: "anonymous@mail.com"
        };
      }
    },
    onEditTemplate(item) {
      this.$router.push("create");
      this.editTemplate(item.data());
    }
  }
};
</script>

<style lang="css">
.market-place .outline,
.market-place .outline-select {
  outline: none !important;
}
</style>
